import React from 'react';
import { NavLink } from 'react-router-dom';
import MessageBadge from 'common/Header/components/MessageBadge';
import keetLogo from 'assets/images/keet-text-logo.png';
import '../footer.scss';

const menu = [
  { key: 'my_tasks', to: '/my_tasks', title: 'My Tasks' },
  { key: 'progress', to: '/progress', title: 'Progress' },
  { key: 'history', to: '/history', title: 'History' },
  {
    key: 'messages',
    to: '/messages',
    title: <MessageBadge>Messages</MessageBadge>,
  },
];

function Footer() {
  return (
    <footer id="keet-footer" className="bg-white bt fw3 f6 w-100">
      <div className="footer-inner mw8 center">
        <div className="footer-row-top flex items-center pv3">
          <div className="flex items-center pl3 flex-auto">
            <img src={keetLogo} alt="Keet logo" className="footer-logo" />
          </div>
          <div className="flex items-center justify-center flex-auto pl4">
            {menu.map((item, index) => (
              <React.Fragment key={item.key}>
                {index > 0 && <span className="footer-separator silver mh2">|</span>}
                <NavLink
                  to={item.to}
                  className="footer-tab link ttu tracked silver ph2"
                  activeClassName="footer-tab--active"
                >
                  {item.title}
                </NavLink>
              </React.Fragment>
            ))}
          </div>
          <div className="footer-bottom flex items-center justify-end silver flex-auto">
            <span>©2026 Limber Health, A Net Health Company, All Rights Reserved</span>
            <span className="footer-separator mh2">|</span>
            <a
              href="https://www.limberhealth.com/privacy-policy"
              className="footer-privacy link silver"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </div>
        </div>
        <div className="footer-row-bottom pv2 ph3">
          <div className="flex justify-center mb2">
            <img src={keetLogo} alt="Keet logo" className="footer-logo" />
          </div>
          <div className="flex items-center justify-center mb2">
            {menu.map((item, index) => (
              <React.Fragment key={item.key}>
                {index > 0 && <span className="footer-separator silver mh2">|</span>}
                <NavLink
                  to={item.to}
                  className="footer-tab link ttu tracked silver ph2"
                  activeClassName="footer-tab--active"
                >
                  {item.title}
                </NavLink>
              </React.Fragment>
            ))}
          </div>
          <div className="footer-bottom flex items-center justify-center silver">
            <span>©2026 Limber Health, A Net Health Company, All Rights Reserved</span>
            <span className="footer-separator mh2">|</span>
            <a
              href="https://www.limberhealth.com/privacy-policy"
              className="footer-privacy link silver"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
